<form #form="ngForm" autocomplete="off" class="md:w-72" novalidate [formGroup]="formGroup" (ngSubmit)="onSubmit()">
  <div class="flex flex-col gap-4">
    <mat-form-field class="gt-xs:pr-3 flex-auto" [floatLabel]="'always'">
      <mat-label>{{ buildKey("CHANGE_EMAIL_NEW_EMAIL") | translate }}</mat-label>

      <input
        class="form-control"
        matInput
        type="email"
        [formControlName]="FormKeys.NEW_EMAIL"
        [placeholder]="buildKey('EMAIL') | translate"
      />

      @if (controlHasError(FormKeys.NEW_EMAIL)) {
        <mat-error>
          @if (controlHasError(FormKeys.NEW_EMAIL, "required")) {
            {{ buildKey("ERROR_REQUIRED") | translate }}
          }
          @if (controlHasError(FormKeys.NEW_EMAIL, "pattern")) {
            {{ buildKey("ERROR_EMAIL") | translate }}
          }
        </mat-error>
      }
    </mat-form-field>

    @if (emailNotificationsAvailable) {
      <div>
        <mat-checkbox color="primary" [formControlName]="FormKeys.UPDATE_ALERTING_EMAIL">
          {{ buildKey("UPDATE_EMAIL.ALSO_FOR_ALERTS") | translate }}
        </mat-checkbox>
      </div>
    }

    <mat-form-field class="gt-xs:pr-3 flex-auto" [floatLabel]="'always'">
      <mat-label>{{ buildKey("PASSWORD") | translate }}</mat-label>

      <input
        class="form-control"
        matInput
        type="password"
        [formControlName]="FormKeys.PASSWORD"
        [placeholder]="buildKey('PASSWORD') | translate"
      />

      @if (controlHasError(FormKeys.PASSWORD)) {
        <mat-error>
          {{ buildKey("ERROR_PASSWORD_REQUIRED") | translate }}
        </mat-error>
      }
    </mat-form-field>

    <div>
      <button
        class="w-full md:w-auto md:min-w-48"
        color="primary"
        mat-raised-button
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>check</mat-icon>
        {{ buildKey("CHANGE_EMAIL") | translate }}
      </button>
    </div>
  </div>
</form>
